(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup"]) return;
  try {
    
  class Popup extends HTMLElement {
    constructor() {
      super();
      const _this = this;

      if (typeof localStorage === 'object') {
        try {
          localStorage.setItem('localStorage', 1);
          localStorage.removeItem('localStorage');
        } catch (e) {
          Storage.prototype._setItem = Storage.prototype.setItem;
          Storage.prototype.setItem = function() {};
        }
        
        var date = Math.round(Date.now() / 1000),
            days = Math.floor((date - localStorage.getItem('popDate')) / 60 / 60 / 24);
        
        if (localStorage.getItem('popState') != 'shown' || days >= Math.max(this.dataset.hide, 0)) {
          setTimeout(() => {
            _this.parentNode.querySelector('[type="checkbox"]').checked = true;
            localStorage.setItem('popState', 'shown');
            localStorage.setItem('popDate', date);
          }, parseInt(this.dataset.delay) * 1000);
        }
      }
    }
  }
  customElements.define('pop-up', Popup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !window.DesignMode) return;
  try {
    
  if (!customElements.get('load-more')) {
    customElements.define('load-more', class LoadMore extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.loadMore.bind(this));
      }

      loadMore(event) {
        event.preventDefault();
        var page = parseInt(event.target.dataset.page) + 1;
        this.dispatchEvent(new CustomEvent('collection:paginate', { bubbles: true, detail: { page: page } }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
